<footer class="footer">
  <div class="">
    <div class="footer-logo-section">
      <div class="footer-first">
        <img src="assets/images/enl-solutions-logo-new.png" alt="Company Logo" class="footer-logo" />
        <div class="social-icons">
          <a href="https://www.linkedin.com/company/enl-solutions" target="_blank" aria-label="LinkedIn">
            <i class="fa fa-linkedin-square"></i>
          </a>
          <a href="mailto:contact@enl.solutions" aria-label="Email">
            <i class="fa fa-envelope"></i>
          </a>
        </div>
      </div>
      <div class="footer-middle">
        <p>&copy; {{currentYear}} ENL Solutions. All rights reserved.</p>
      </div>
      <div class="footer-end">
        <a routerLink="/termsandconditions">Terms of Service</a>
        <a routerLink="/cookiespolicy">Cookies</a>
        <a href="mailto:contact@enl.solutions" target="_blank">Contact Us & Feedback</a>
        <a routerLink="/privacypolicy">Privacy</a>
      </div>

    </div>
  </div>
</footer>